// extracted by mini-css-extract-plugin
export default {"titulo-capital-humano":"CapitalHumano_titulo-capital-humano__NWUpC"};